import type { WelcomeDelivery2ScreenModel } from './WelcomeDelivery2ModelScreen';

export class WelcomeDelivery2Controller {
  constructor(private readonly model: WelcomeDelivery2ScreenModel) {}

  handleContinue = () => {
    this.model.onContinue?.();
  };
}
